// config.js
export const stripePublicKey = 'pk_test_51OR9ulSAclSOEbyfkJxCNomQssX5obRdddOGnK1oyfV9Z8RjbtgccEF8U8WqoHNAteYnrBqy8pyf9hu5R8Mfv1ME00C10SfXiB';

export const axiosBaseUrl = 'https://us-central1-clone-e0935.cloudfunctions.net/api';
//http://127.0.0.1:5001/clone-e0935/us-central1/api'

export const firebaseConfig = {
  apiKey: "AIzaSyAf1_TrvQKfsFoYxc3IFNjyAB8tEyRJQeo",
  authDomain: "clone-e0935.firebaseapp.com",
  projectId: "clone-e0935",
  storageBucket: "clone-e0935.appspot.com",
  messagingSenderId: "132011621061",
  appId: "1:132011621061:web:9a917d3b23c52726adceac"
};

